import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Toggle } from "src/UI/Toggle";

interface QuestionToggleProps {
  question?: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  noLabel: string;
  yesLabel: string;
  disabled?: boolean;
}

const QuestionToggle: React.FC<QuestionToggleProps> = ({
  question,
  description,
  checked,
  onChange,
  noLabel,
  yesLabel,
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {question && (
          <Typography
            sx={{
              fontSize: "1rem",
              color: theme.palette.text.primary,
            }}
          >
            {question}
          </Typography>
        )}
        <Toggle
          noLabel={noLabel}
          yesLabel={yesLabel}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
      </Box>
      {description && (
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.tertiary,
            lineHeight: "1rem",
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default QuestionToggle;
